import { render, staticRenderFns } from "./AdDetail.vue?vue&type=template&id=2be90722&scoped=true"
import script from "./AdDetail.vue?vue&type=script&lang=js"
export * from "./AdDetail.vue?vue&type=script&lang=js"
import style0 from "./AdDetail.vue?vue&type=style&index=0&id=2be90722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be90722",
  null
  
)

export default component.exports